module.exports = __webpack_public_path__ + "img/Weapon_272.e8ff5efd.png";